import React, { Component } from "react";
import ReactCardCarousel from "react-card-carousel";
import { FaChevronCircleDown, FaChevronCircleUp  } from "react-icons/fa";

const FrontList = [
  {
    icon: 'https://animusdevelopment.b-cdn.net/images/tech/react.png',
    link: '/custom-software',
    title: 'React',
    description: 'React is an open-source JavaScript library for building user interfaces or UI components. It is maintained by Facebook and a community of individual developers and companies.'
  },
  {
    icon: 'https://animusdevelopment.b-cdn.net/images/tech/react_native.png',
    link: '/prototyping',
    title: 'React Native',
    description: 'React Native is an open-source mobile application framework created by Facebook, Inc. It is used to develop applications for Android, iOS, Web and UWP by enabling developers to use React along with native platform capabilities.'
  },
  {
    icon: 'https://animusdevelopment.b-cdn.net/images/tech/vue.png',
    link: '/prototyping',
    title: 'Vue',
    description: 'Vue.js is an open-source model–view–viewmodel JavaScript framework for building user interfaces and single-page applications. It was created by Evan You, and is maintained by him and the rest of the active core team members coming from various companies such as Netlify.'
  },
  {
    icon: 'https://animusdevelopment.b-cdn.net/images/tech/gatsby.png',
    link: '/prototyping',
    title: 'Gatsby',
    description: 'Gatsby loads only critical parts of the page, so your site loads as fast as possible. Once loaded, Gatsby prefetches resources for other pages so that clicking on the site feels incredibly fast. Gatsby lets teams focus on creating content-driven websites instead of worrying about performance.'
  }
]

class FrontEnd extends Component{
  constructor(props) {
    super(props);
    this.Carousel = React.createRef();
    this.handleClickDown = this.handleClickDown.bind(this);
    this.handleClickUp = this.handleClickUp.bind(this);
  }

  handleClickDown() {
    this.Carousel.current.prev();
  }

  handleClickUp() {
    this.Carousel.current.next();
  }

  render(){

    return(
      <React.Fragment>
        <div className="section fp-section fp-tabble" data-black-overlay="7">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-12 order-2 order-lg-1">
                <div className="tech-services">
                  <ReactCardCarousel spread={"narrow"} autoplay={true} autoplay_speed={5000} alignment={"vertical"} disable_box_shadow disable_keydown={true} ref={ this.Carousel }>
                    {FrontList.map( (val , i) => (
                      <div className="col-lg-6 col-md-6 col-sm-6 col-12" key={i}>
                        <div className="service tech-cards--1 tech-cards">
                          <div className="icon d-flex justify-content-center">
                            <img src={val.icon} alt="Tech" />
                          </div>
                          <div className="content">
                            <h3 className="title">{val.title}</h3>
                            <p>{val.description}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </ReactCardCarousel>
                </div>
              </div>
            <div className="col-lg-6 col-12 order-1 order-lg-2 pt_sm--100">
                <div className="section-title mt--30 mt_md--5 mt_mobile--5 mb_mobile--10">
                  <h2 className="title">Frontend Development</h2>
                  <p>𝝠nimus architecture & design services build engaging User Interface (UI) experiences using cutting-edge technologies. Our team of experienced front-end developers help create user friendly interfaces based on the latest industry trends that leverage our full software stack. We use our front-end expertise to create innovative, human-centric, goal-oriented web & mobile solutions.</p>
                  <div className="tech-arrow row">
                    <div className="col d-flex justify-content-center">
                      <FaChevronCircleUp className="solution-click" style={{fontSize: '3em', cursor: 'pointer', marginRight: '20px'}} onClick={this.handleClickUp} />
                      <FaChevronCircleDown className="solution-click" style={{fontSize: '3em', cursor: 'pointer', marginLeft: '20px'}} onClick={this.handleClickDown} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}
export default FrontEnd;
